import { Study } from '@mitsubishi/shared/data-access';

import { Selector } from '@ngxs/store';

import { Project, ProjectDetails, Selection } from '../../models';
import { EnergyAnalysis } from '../../models/energy-analysis.model';
import { ProjectState, ProjectStateModel } from './project.state';

export class ProjectSelectors {
  @Selector([ProjectState])
  static current(state: ProjectStateModel) {
    return state?.current;
  }

  @Selector([ProjectSelectors.current])
  static projectDetails(state: Project) {
    return state?.details;
  }

  @Selector([ProjectSelectors.current])
  static projectSelections(details: Project): Selection[] {
    return Object.values(details?.selections ?? {});
  }

  @Selector([ProjectSelectors.current])
  static projectDocuments(details: Project) {
    return Object.values(details?.documents ?? {});
  }

  @Selector([ProjectSelectors.projectDetails])
  static projectId(details: ProjectDetails) {
    return details?.uuid;
  }

  @Selector([ProjectSelectors.projectDetails])
  static projectCode(details: ProjectDetails) {
    return details?.code;
  }

  @Selector([ProjectSelectors.current])
  static projectCompanies(details: Project) {
    return Object.values(details?.companies ?? {});
  }

  @Selector([ProjectSelectors.current])
  static projectStudies(details: Project): Study[] {
    if (!details || !details.studies) {
      return [];
    }

    return Object.values(details.studies);
  }

  @Selector([ProjectSelectors.current])
  static projectEnergyAnalysis(details: Project): EnergyAnalysis[] {
    return Object.values(details?.energyAnalysis ?? {});
  }

  @Selector([ProjectSelectors.projectDetails])
  static projectOrganizationId(details: ProjectDetails) {
    return details.organizationId;
  }

  @Selector([ProjectSelectors.current])
  static canUpdateProjectCertificationOrUnitMeasures(project: Project) {
    const selectionHasUnits = Object.values(project.selections).some(sel => sel.base.unitCount);
    const selectionHasHiddenUnits = Object.values(project.selections).some(sel => sel.base.hiddenUnitIdList.length > 0);
    const studyHasUnits = Object.values(project.studies).some(study =>
      Object.values(study.subcategories).some(sub => Object.values(sub.units).some(unit => unit))
    );

    const hasCertificatedStudies = Object.values(project.studies).some(study => study.certified);

    return !selectionHasUnits && !selectionHasHiddenUnits && !studyHasUnits && !hasCertificatedStudies;
  }

  @Selector([ProjectSelectors.current])
  static projectCertification(project: Project) {
    return project.details.certification;
  }

  @Selector([ProjectSelectors.current])
  static projectFeature(project: Project) {
    return project.details.elcaFeature;
  }
}
